export const studentProfileKeys = {
  all: ["student-profile"] as const,
  overviews: () => [...studentProfileKeys.all, "overview"] as const,
  overview: (profileId: string) => [...studentProfileKeys.overviews(), profileId] as const,
  notes: (profileId: string) => [...studentProfileKeys.all, "notes", profileId] as const,
}
